import identity from "lodash/fp/identity";

class ContractorInvoiceItemPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return identity(data);
  }
}

export default ContractorInvoiceItemPageTransform;



// WEBPACK FOOTER //
// ./src/pages/contractorInvoiceItem/contractorInvoiceItem.transforms.js